import { render, staticRenderFns } from "./liveMore.vue?vue&type=template&id=4c0a2e96&scoped=true&"
import script from "./liveMore.vue?vue&type=script&lang=js&"
export * from "./liveMore.vue?vue&type=script&lang=js&"
import style0 from "./liveMore.vue?vue&type=style&index=0&id=4c0a2e96&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0a2e96",
  null
  
)

export default component.exports